import { z } from 'zod';

import { BrandMemberSchema, GetBrandMembersQuerySchema } from './brand-user';
import { EmailStringSchema } from '../../common';
import { buildQueryString } from '../../utils/querystring';
import { makeEndpoint, paginateQuerySchema, paginateResponseSchema, sortOptions } from '../common';

export enum HostCommissionSortBy {
  START_DATE_TIME = 'startDateTime',
  AMOUNT = 'amount',
  INITIATED_ON = 'scheduledAt',
  PAYOUT_DATE = 'payoutArrivalDate',
}

export const PatchBrandHostRequestSchema = z.object({
  allowOverlappingBookings: z.boolean(),
});

export const PatchBrandHostEndpoint = makeEndpoint({
  method: 'PATCH',
  url: ({ brandId, hostId }: { brandId: string; hostId: string }) => `/brands/${brandId}/hosts/${hostId}`,
  responseSchema: z.void(),
  requestSchema: PatchBrandHostRequestSchema,
});

export const AllPaginatedHostsResponse = paginateResponseSchema(
  z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: EmailStringSchema,
    profilePicture: z.object({ id: z.string(), uri: z.object({ original: z.string() }) }).nullable(),
  }),
);

export const GetAllHostsQuerySchema = z
  .object({
    q: z.string().optional(),
    page: z.coerce.number().min(1).default(1),
    limit: z.coerce.number().min(1).default(10),
  })
  .strict();

export const GetBrandHostsEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, query }: { brandId: string; query: z.infer<typeof GetBrandMembersQuerySchema> }) =>
    `v1/brands/${brandId}/hosts?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(BrandMemberSchema),
  requestSchema: z.void(),
  querySchema: GetBrandMembersQuerySchema,
});

export const GetBrandsHostCommissionQuerySchema = paginateQuerySchema({})
  .omit({
    q: true,
    filters: true,
    sortBy: true,
    sortDir: true,
  })
  .extend({
    sortBy: z.nativeEnum(HostCommissionSortBy).optional(),
    sortOrder: z.enum(sortOptions).optional(),
  });
